import { useTranslation } from "next-i18next";
import Image from "next/image";

const TechnicalSpecificationsWindowsServers = () => {
    const { t } = useTranslation(["common", "windowsCloudServer"]);

    return (
        <div className="relative p-5 services bg-makdosSecondaryGray">
            <div className="container px-2 py-10 mx-auto lg:space-x-4 lg:py-20 lg:px-0">
                <h2 className="font-semibold text-3xl mb-3 lg:text-[40px] lg:text-center text-textGray">{t("common:technicalSpecificationsWindowsServers")}</h2>
                <div className="text-sm lg:text-base lg:text-center lg:!mx-[150px] text-textGray" dangerouslySetInnerHTML={{ __html: t("common:technicalSpecificationsWindowsServersDesc") }}>
                </div>

                <div className="grid grid-cols-12 gap-8 mx-auto mt-16">
                    <div className="flex items-center justify-center col-span-12 my-10 lg:col-span-5">
                        <Image
                            src={"/windowVirtualServerTechnicalProperty.svg"}
                            width={520}
                            height={494}
                            alt={t("windowsCloudServer:technicalSpecificationsOfWindowsVirtualServers")}
                            title={t("windowsCloudServer:technicalSpecificationsOfWindowsVirtualServers")}
                        />
                    </div>

                    <div className="lg:h-[584px] overflow-y-auto scrollbar-custom  lg:pr-10 space-y-8 col-span-12 lg:col-span-7">
                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:uninterruptedServiceWithClusterInfrastructure")}</p>
                            <div className="text-sm lg:text-base text-textGray" dangerouslySetInnerHTML={{ __html: t("common:uninterruptedServiceWithClusterInfrastructureDesc") }}></div>
                        </div>

                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:storageBasedDiskStructure")}</p>
                            <p className="text-sm lg:text-base text-textGray">
                                {t("common:storageBasedDiskStructureDesc")}
                            </p>
                        </div>

                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:highAvailabilityDynamicResourceManagement")}</p>
                            <p className="text-sm lg:text-base text-textGray">
                                {t("common:highAvailabilityDynamicResourceManagementDesc")}
                            </p>
                        </div>

                        {/* <div className="space-y-4">
                            <p className="text-sm font-semibold text-textGray">• {t("common:strongSecurityMeasures")}</p>
                            <div className="text-sm text-textGray" dangerouslySetInnerHTML={{ __html: t("common:strongSecurityMeasuresDesc") }}></div>
                        </div> */}

                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:highInternetSpeed")}</p>
                            <p className="text-sm lg:text-base text-textGray">
                                {t("common:highInternetSpeedDesc")}
                            </p>
                        </div>

                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:advancedBackupAndDataManagement")}</p>
                            <p className="text-sm lg:text-base text-textGray">
                                {t("common:advancedBackupAndDataManagementDesc")}
                            </p>
                        </div>

                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:flexibleResourceManagement")}</p>
                            <div className="text-sm lg:text-base text-textGray" dangerouslySetInnerHTML={{ __html: t("common:flexibleResourceManagementDesc") }}></div>
                        </div>

                        <div className="space-y-4">
                            <p className="text-sm font-semibold lg:text-base text-textGray">• {t("common:advancedDataCenterInfrastructure")}</p>
                            <p className="text-sm lg:text-base text-textGray">
                                {t("common:advancedDataCenterInfrastructureDesc")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TechnicalSpecificationsWindowsServers